import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import offlineRfsRemote from '../../../api/offlineRfsRemote';
import gmapsReqHandler from '../../../api/googleMapsRemote';

import DriverETADriver from './DriverETADriver';

import User from '../../../models/User';
import ApiResponse from '../../../models/ApiResponse';
import { OfflineRfsOrder } from '../../../models/OfflineRfs';
import ResponseError from '../../../models/ResponseError';

import moment, { Moment } from 'moment';
import { PO_SCHEMA } from '../../../utils/offlineOrder';

interface DriverETAOfflineContainerProps {
  user: User;
  history: any;
  match: { params: { number: string, secretKey: string } };
  receiveError: (error: ResponseError) => void;
  receiveSuccess: (message: string) => void;
};

interface DriverETAOfflineContainerState {
  doo: OfflineRfsOrder;
  dooNumber: number;
  secretKey: string;
  dropOffTimeError: boolean;
  tabValue: number;
  setETAAuto: boolean;
  userLocation: { lat: number, lng: number } | null;
  destination: { lat: number, lng: number } | null;
  durationValue: number;
  arrivalTime: Date;
  arrivesIn: string;
  eta: string
};

class DriverETAOfflineContainer extends Component<DriverETAOfflineContainerProps, DriverETAOfflineContainerState> {

  state = {
    doo: PO_SCHEMA,
    dooNumber: 0,
    secretKey: '',
    dropOffTimeError: false,
    tabValue: 0,
    userLocation: null,
    destination: null,
    setETAAuto: false,
    durationValue: 0,
    arrivalTime: new Date(),
    arrivesIn: '',
    eta: ''
  }

  componentDidMount() {

    this.load();
  }

  load = (): void => {
    const dooNumber: number = parseInt(this.props.match.params.number);
    const secretKey: string = this.props.match.params.secretKey;

    offlineRfsRemote.getOfflineRfsOrderDetails(dooNumber, secretKey).then((resp: ApiResponse<OfflineRfsOrder>) => {

      const doo: OfflineRfsOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (doo) {
        
        const dropOffOrder: OfflineRfsOrder = { ...doo };
        dropOffOrder.pickup_time = doo.latest_eta;

        let _eta = (dropOffOrder.departure_date)? moment(dropOffOrder.departure_date).format('DDMMMYY').toUpperCase()+' '+moment(dropOffOrder.departure_time).format('HH:mm') :  moment(dropOffOrder.schedule_date).format('DDMMMYY').toUpperCase()+' '+moment(dropOffOrder.schedule_time).format('HH:mm')

        this.setState({ doo: dropOffOrder, dooNumber, secretKey, eta: _eta });

        // Get current user position
        navigator.geolocation.getCurrentPosition(
          position => {
            const { latitude, longitude } = position.coords;
            let dropoffAdress: string = '';
            if(dropOffOrder.info) {
              dropoffAdress = dropOffOrder.info.addr1 + ' ' + dropOffOrder.info.addr2 + ' ' + dropOffOrder.info.city + ' ' + dropOffOrder.info.state + ' ' + dropOffOrder.info.zip;
            }

            // Get geolocation of destination
            gmapsReqHandler.getGeoCode(dropoffAdress).then((geocodeRes: { data: { error_message: string, results: { geometry: { location: { lat: number, lng: number } } }[], status: string } }) => {
              
              let geocodeData = geocodeRes.data;

              if (geocodeData.error_message) {

                this.props.receiveError({ errorCode: "#couldntLoadGmaps", longDescription: "Couldn't get coordinates of destination." });

              } else {

                let destination: { lat: number, lng: number } = geocodeData.results[0].geometry.location;

                // Calculate distance
                gmapsReqHandler.getDistance(`${latitude}, ${longitude}`, `${destination.lat}, ${destination.lng}`).then((resp: ApiResponse<number>) => {

                  const result: number | undefined = resp.result;
                  const error: ResponseError | undefined = resp.error;

                  if (result) {
                    let d: Date = new Date();
                    d.setSeconds(d.getSeconds() + result);
                    let arrivesIn: string = Math.floor(result / 60 / 60) + ":" + Math.floor(result % 3600 / 60);
                    this.setState({ destination, setETAAuto: true, userLocation: { lat: latitude, lng: longitude }, durationValue: result, arrivalTime: d, arrivesIn });
                  }

                  if (error) {
                    this.props.receiveError(error);
                  };
                });
              }
            });
          },
          () => {
            this.props.receiveError({ errorCode: "#couldntLoadGmaps", longDescription: "Couldn't get current location." });
          }
        );

      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  setETADriver = (time: string): void => {

    offlineRfsRemote.setETA(this.state.dooNumber, this.props.match.params.secretKey, this.state.arrivalTime.toString()).then((resp: ApiResponse<boolean>) => {
      
      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.props.receiveSuccess("Successfully set ETA");
      };
      if (error) {
        this.props.receiveError(error);
      };
    })
  };

  selectETA = (): void => {

    const currState: DriverETAOfflineContainerState = { ...this.state };
    const dooNumber: Number = currState.dooNumber;
    const secretKey: string = currState.secretKey;
    
    if (dooNumber && secretKey) {
      this.props.history.push(`/drv-map/do/${dooNumber}/${secretKey}`);
    }
  }

  handleDropOffTimeChange = (dateTime: Moment): void => {

    const doo: OfflineRfsOrder = { ...this.state.doo };

    if (doo.cutoff_time) {

      const cutOffTime: Date = moment(doo.cutoff_time, "HHmm").toDate();
      const dropOffTime: Date = moment(dateTime, "HHmm").toDate();
      const dropOffTimeStr: string = moment(dateTime).format('HHmm');
      let dropOffTimeError: boolean = this.state.dropOffTimeError;
  
      if (doo.pickup_date < doo.cutoff_date || dropOffTime <= cutOffTime) {
  
        dropOffTimeError = false;
      } else {
  
        dropOffTimeError = true;
      }
  
      doo.pickup_time = dropOffTimeStr;
      this.setState({ doo, dropOffTimeError });
    }

  }

  changeEta = (event: any): void => {
    const time: any = event;
    this.setState({ arrivalTime: time });
    
  }

  handleChange = (event: any, newValue: number) => {

    this.setState({ tabValue:newValue });
  };

   handleUpdate = async (type: string): Promise<void> => {

    //console.log('handleUpdate')
    if(type === 'auto') {
      if (this.props.match.params.number) {

        offlineRfsRemote.getGhaTime(parseInt(this.props.match.params.number), this.state.durationValue).then((resp: ApiResponse<{ date: string, time: string }>) => {
        
        const result: { date: string, time: string } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (result) {
          this.setETADriver(result.time);
        };
        if (error) {
          this.props.receiveError(error);
        };
      });
    };
    } else {
      const time = moment(this.state.arrivalTime).format('HHmm');
      this.setETADriver(time);
    }
      
  }

  render() {

    return (
      <DriverETADriver
        dropOffOrder={ this.state.doo }
        dropOffTimeError={ this.state.dropOffTimeError }
        selectETA={ this.selectETA }
        pickupDate={ this.state.doo.pickup_date}
        tabValue={ this.state.tabValue }
        handleChange={ this.handleChange }
        destination={ this.state.destination }
        userLocation={ this.state.userLocation }
        handleUpdate= { this.handleUpdate }
        eta= { this.state.eta }
        setETAAuto={ this.state.setETAAuto }
        arrivalTime={ this.state.arrivalTime }
        changeEta={ this.changeEta }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DriverETAOfflineContainer);